import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, History as HistoryIcon, LogOut, Gauge } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const nav = [
    { to: "/app", label: "Gerador", icon: Sparkles, testid: "nav-generator" },
    { to: "/app/historico", label: "Histórico", icon: HistoryIcon, testid: "nav-history" },
  ];

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="bg-noise min-h-screen flex" style={{ background: "var(--avsl-bg)" }}>
      {/* Sidebar */}
      <aside
        className="hidden md:flex flex-col w-[240px] shrink-0 border-r"
        style={{ background: "var(--avsl-sidebar)", borderColor: "var(--avsl-border)" }}
        data-testid="sidebar"
      >
        <div className="px-6 py-7 border-b" style={{ borderColor: "var(--avsl-border)" }}>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 flex items-center justify-center" style={{ background: "var(--avsl-red)" }}>
              <Gauge size={20} strokeWidth={2.5} color="#fff" />
            </div>
            <div>
              <div className="font-display text-xl leading-none">AVSL</div>
              <div className="overline mt-1">Ad Studio</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-6 space-y-1">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/app"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 border transition-colors duration-200 ${
                  isActive
                    ? "border-red-600 text-white bg-[#171010]"
                    : "border-transparent text-neutral-400 hover:text-white hover:border-white/10"
                }`
              }
            >
              <item.icon size={18} strokeWidth={2.5} />
              <span className="font-display-straight tracking-wider text-sm">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="px-4 py-4 border-t" style={{ borderColor: "var(--avsl-border)" }}>
          <div className="text-xs text-neutral-500 truncate" data-testid="user-email">{user?.email}</div>
          <button
            data-testid="logout-btn"
            onClick={doLogout}
            className="mt-3 w-full flex items-center justify-center gap-2 avsl-btn-ghost avsl-btn"
          >
            <LogOut size={16} strokeWidth={2.5} /> Sair
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="flex-1 flex flex-col min-w-0">
        <header
          className="md:hidden flex items-center justify-between px-4 py-3 border-b"
          style={{ background: "var(--avsl-sidebar)", borderColor: "var(--avsl-border)" }}
        >
          <div className="font-display text-lg">AVSL <span style={{ color: "var(--avsl-red)" }}>AD STUDIO</span></div>
          <button data-testid="logout-btn-mobile" onClick={doLogout} className="text-xs text-neutral-400 uppercase tracking-widest">
            Sair
          </button>
        </header>
        <main className="flex-1 relative z-10">{children}</main>
      </div>
    </div>
  );
}
